exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n    [class*=\" el-icon-lx\"], [class^=el-icon-lx] {\n        font-family: lx-iconfont!important;\n    }", ""]);

// exports
